import styled from "styled-components";

const Button = styled.div`
  display: inline-block;
  cursor: pointer;
  background: #007aff;
  color: white;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  font-weight: 600;
  vertical-align: top;
  border-radius: 2px 0 0px 2px;
  box-sizing: border-box;
  margin-top: 1px;

  &:after {
    content: "-";
  }
`;

export default Button;
